const PREFIX = 'OPEN_PLATFORM_APP_LEARN_MORE_';

export const OPEN_PLATFORM_APP_LEARN_MORE_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;
export const OPEN_PLATFORM_APP_LEARN_MORE_SET_APP = `${PREFIX}SET_APP`;
export const OPEN_PLATFORM_APP_LEARN_MORE_RESET = `${PREFIX}RESET`;
export const OPEN_PLATFORM_APP_LEARN_MORE_ON_CHANGE_FIELD = `${PREFIX}ON_CHANGE_FIELD`;
